var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApollo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 41,
    viewBox: "0 0 40 41",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m34.1421 34.1597c-7.8105 7.8105-20.4738 7.8105-28.28424 0-7.81048-7.8105-7.81048-20.4738 0-28.28425 7.81044-7.81048 20.47374-7.81048 28.28424 0 7.8105 7.81045 7.8105 20.47375 0 28.28425z",
    fill: "#00dc55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m25.5668 24.2445c-2.0071-.9368-3.8924-2.2204-5.5655-3.851l-13.95357 13.9535c-.06359-.0619-.12686-.1243-.18982-.1873-.06294-.0629-.12538-.1262-.18731-.1898l13.9536-13.9535c-1.6308-1.6734-2.9146-3.5589-3.8515-5.5663l-15.7136878 7.1068c-.0145526-.1897-.0264098-.3795-.0355747-.5694l15.5301625-7.0237c-1.814-4.17198-2.1573-8.82975-1.03-13.185586.1975-.056023.3957-.108951.5945-.158783-1.1898 4.322289-.8827 8.970429.9216 13.124469l17.8807-8.08682c.0744.0721.1483.14489.2218.21837.0734.07346.1462.14735.2183.22165l-8.0875 17.8805c4.1543 1.8045 8.8027 2.1118 13.1252.9218-.0498.1989-.1028.397-.1588.5945-4.3561 1.1274-9.0141.784-13.1862-1.0302l-7.0245 15.5304c-.1899-.0092-.3797-.021-.5694-.0356zm-9.3079-10.0142 16.7077-7.55634-12.9653 12.96524c-1.5839-1.6265-2.8314-3.4586-3.7424-5.4089zm17.0844-7.17882-12.9649 12.96482c1.6263 1.5838 3.4582 2.8312 5.4083 3.7421z",
    fill: "#1d3301",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApollo);
export default __webpack_public_path__ + "static/media/apollo.1168aa6b6d98af59072506bfd3998062.svg";
export { ForwardRef as ReactComponent };